import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toJS } from 'mobx';
import { cast, getParent, getRoot, types } from 'mobx-state-tree';
import moment from 'moment';
import { api } from 'src/api';
import { createAsync, createSilentAsync } from 'src/utils/asyncModel';
import { sortCycles } from 'src/utils/date';
// import { ALLOCATION_METHOD, UTILITIES_STATUSES } from 'src/constants/utilities';

const getAddBillingCycleAsync = createAsync(body => {
  return async function getAddBillingCycle(options) {
    const resp = await api.Allocations.getAddBillingCycle(body, options);
    return resp;
  };
});
const getAllocationComparisonAsync = createAsync(body => {
  return async function getAllocationComparison(options) {
    var _property$allocations, _property$allocations2;
    const resp = await api.Allocations.getAllocationComparison(body, options);
    const _getParent = getParent(this),
      homeDashboardStore = _getParent.homeDashboardStore;
    const property = homeDashboardStore.selectedPropertyId === 'all' ? homeDashboardStore.getCurrentCompanyProperties.find(p => p.id === body.propertyId) : homeDashboardStore.getCurrentProperty;
    const utility = property === null || property === void 0 || (_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.utilityById.get(body.billingCycleId + body.utilityId);
    if (!utility) property === null || property === void 0 || (_property$allocations2 = property.allocations) === null || _property$allocations2 === void 0 || _property$allocations2.setComparisonByIdAfterFetch(body.billingCycleId + body.utilityId, resp);else utility.setComparisonAfterFetch(resp);
    return resp;
  };
});
const getAllocationHistoryAsync = createAsync(body => {
  return async function getAllocationHistory(options) {
    const applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToHomeDashboard;
    const resp = await api.Allocations.getAllocationHistory(body.data, options);
    const _getParent2 = getParent(this),
      allocations = _getParent2.allocations;
    allocations.setAllocationHistoryAfterLoad(resp);
    if (applyToHomeDashboard) {
      var _getRoot$homeDashboar;
      (_getRoot$homeDashboar = getRoot(this).homeDashboardStore.getCurrentProperty) === null || _getRoot$homeDashboar === void 0 || (_getRoot$homeDashboar = _getRoot$homeDashboar.allocations) === null || _getRoot$homeDashboar === void 0 || _getRoot$homeDashboar.setAllocationHistory(resp.response);
    }
    return resp;
  };
});
const getAllocationPreviewAsync = createAsync(body => {
  return async function getAllocationPreview(options) {
    const resp = await api.Allocations.getAllocationPreview(body, options);
    const _getParent3 = getParent(this),
      allocations = _getParent3.allocations,
      homeDashboardStore = _getParent3.homeDashboardStore;

    // ****   Submetered Utility Injection   ****
    // TODO: Remove on behalf of LB-4758
    // const submeterFFEnabled = account.featureFlagsStore.getIsSubmeterInterimSolutionEnabled;
    // if (submeterFFEnabled && false) await performExtraActions(resp, body, options, true);
    // **** Submetered Utility Injection ****

    allocations.setCycleAfterLoad(body.billingCycleId, resp);
    const property = homeDashboardStore.selectedPropertyId === 'all' ? homeDashboardStore.getPropertyById(body.propertyId) : homeDashboardStore.getCurrentProperty;
    property === null || property === void 0 || property.allocations.setCycleAfterFetch(body.billingCycleId, resp);
    return resp;
  };
});

/**
 * Suggested allocation tables for bill values the user is still editing. Every property/utility on
 * the bill goes in one call, so a newer edit cancels the whole previous suggestion instead of leaving
 * half the tables from the old values on screen.
 */
const postAllocationSuggestionAsync = createAsync(body => {
  return async function postAllocationSuggestion(options) {
    const resp = await api.Allocations.postAllocationSuggestion(body, options);
    return resp;
  };
});
const getAllocationsHistoryAsync = createAsync(body => {
  return async function getAllocationsHistory(options) {
    const resp = await api.Allocations.getAllocationsHistory(body, options);
    const _getParent4 = getParent(this),
      allocations = _getParent4.allocations;
    allocations.setAllocationsHistoryAfterLoad(resp);
    return resp;
  };
});
const getAllocationTableAggregateAsync = createAsync(body => {
  return async function getAllocationTableAggregate(options) {
    var _homeDashboardStore$g, _utility$allocations;
    const resp = await api.Allocations.getAllocationTableAggregate(body, options);
    const _getParent5 = getParent(this),
      account = _getParent5.account,
      allocations = _getParent5.allocations,
      homeDashboardStore = _getParent5.homeDashboardStore;

    // // ****   Submetered Utility Injection   ****
    // const submeterFFEnabled = account.featureFlagsStore.getIsSubmeterInterimSolutionEnabled;
    // if (submeterFFEnabled) {
    //   await performExtraActions(resp, body, options);
    // }
    // // **** Submetered Utility Injection ****

    if (body.utilityId) allocations.setUtilityAfterLoad(body.billingCycleId, body.utilityId, resp);else allocations.setTableAfterLoad(resp, body.billingCycleId);
    const property = homeDashboardStore.selectedPropertyId === 'all' ? homeDashboardStore.getCurrentCompanyProperties.find(p => p.id === body.propertyId) : homeDashboardStore.getCurrentProperty;
    property === null || property === void 0 || property.allocations.setUtilityAfterFetch(body.billingCycleId, body.utilityId, resp);
    (_homeDashboardStore$g = homeDashboardStore.getCurrentCompany) === null || _homeDashboardStore$g === void 0 || _homeDashboardStore$g.billingTab.setAllocationBatchIdAfterFetch(resp);
    const utility = allocations.utilityById.get(body.billingCycleId + body.utilityId);
    const accountIds = (utility === null || utility === void 0 || (_utility$allocations = utility.allocations) === null || _utility$allocations === void 0 ? void 0 : _utility$allocations.map(c => c.residentAccountId).filter(id => id)) || [];
    const cycleChargesPreviewListIds = allocations.cycleChargesPreviewList.map(c => c.residentAccountId).filter(id => id);
    const ids = [...new Set([...accountIds, ...cycleChargesPreviewListIds])];
    const difference = ids.filter(x => !account.accountIds.includes(x));
    if (difference.length > 0) await account.getUsersProfilesAsync.run({
      accountIds: difference
    });
    return resp;
  };
});
const getAllocationTableInfoAsync = createAsync(body => {
  return async function getAllocationTableInfo(options) {
    const resp = await api.Allocations.getAllocationTableInfo(body, options);
    return resp;
  };
});
const postBillCreatedAsync = createAsync(body => {
  return async function postBillCreated(options) {
    const resp = await api.Allocations.postBillCreated(body, options);
    return resp;
  };
});
const getBillingCyclesAsync = createAsync(body => {
  return async function getBillingCycles(options) {
    const resp = await api.Allocations.getBillingCycles(body, options);
    const _getParent6 = getParent(this),
      allocations = _getParent6.allocations;
    allocations.setBillingCyclesFetched(body.allocationCycleId + body.propertyId);
    return resp;
  };
});
const getBillingSummaryAsync = createAsync(body => {
  return async function getBillingSummary(options) {
    const resp = await api.Allocations.getBillingSummary(body, options);
    return resp;
  };
});
const getBillsAsync = createAsync(body => {
  return async function getBillsAllocations(options) {
    const resp = await api.Allocations.getBillsAllocations(body, options);
    const _getParent7 = getParent(this),
      allocations = _getParent7.allocations;
    allocations.setBillsAfterLoad(resp);
    return resp;
  };
});
const putBillUpdatedAsync = createAsync(body => {
  return async function putBillUpdated(options) {
    const resp = await api.Allocations.putBillUpdated(body, options);
    return resp;
  };
});
const getBillsFileCabinetAsync = createAsync(body => {
  return async function getBillsFileCabinet(options) {
    const resp = await api.Allocations.getBillsFileCabinet(body, options);
    return resp;
  };
});
const getCurrentCycleAsync = createAsync(body => {
  return async function getCurrentCycle(options) {
    const applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToHomeDashboard;
    const resp = await api.Allocations.getCurrentCycle(body, options);
    const _getParent8 = getParent(this),
      allocations = _getParent8.allocations,
      payment = _getParent8.payment,
      homeDashboardStore = _getParent8.homeDashboardStore;
    if (applyToHomeDashboard) {
      var _homeDashboardStore$g2, _resp$response, _homeDashboardStore$g3, _resp$response2;
      homeDashboardStore === null || homeDashboardStore === void 0 || (_homeDashboardStore$g2 = homeDashboardStore.getCurrentCompany) === null || _homeDashboardStore$g2 === void 0 || _homeDashboardStore$g2.setDaysTillStatementDate(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.daysTillStatementDate);
      homeDashboardStore === null || homeDashboardStore === void 0 || (_homeDashboardStore$g3 = homeDashboardStore.getCurrentCompany) === null || _homeDashboardStore$g3 === void 0 || _homeDashboardStore$g3.setCurrentAllocationCycleId(resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.id);
    }
    allocations.setCurrentCycleAfterLoad(resp);
    payment.setDueOnDateOnly(resp);
    return resp;
  };
});
const deleteBillingCycleAsync = createAsync(body => {
  return async function deleteBillingCycle(options) {
    const resp = await api.Allocations.deleteBillingCycle(body, options);
    return resp;
  };
});

/** Silent: a refusal (an allocation already billed) is the service's own words, said by the screen that asked. */
const removeBillAsync = createSilentAsync(body => {
  return async function removeBill(options) {
    const resp = await api.Allocations.removeBill(body, options);
    return resp;
  };
});
const getFileAttachedAsync = createAsync(body => {
  return async function getFileAttached(options) {
    const resp = await api.Allocations.getFileAttached(body, options);
    return resp;
  };
});
const getPropertyBillsFileCabinetAsync = createAsync(body => {
  return async function getPropertyBillsFileCabinet(options) {
    const resp = await api.Allocations.getPropertyBillsFileCabinet(body, options);
    return resp;
  };
});
const getSkippedCyclesAsync = createAsync(body => {
  return async function getSkippedCycles(options) {
    const resp = await api.Allocations.getSkippedCycles(body, options);
    const _getParent9 = getParent(this),
      allocations = _getParent9.allocations;
    allocations.setSkippedCyclesAfterLoad(resp);
    return resp;
  };
});
const postTableApprovalAsync = createAsync(body => {
  return async function postTableApproval(options) {
    const resp = await api.Allocations.postTableApproval(body, options);
    return resp;
  };
});
const postCustomBillingCycleAsync = createAsync(body => {
  return async function postCustomBillingCycle(options) {
    const resp = await api.Allocations.postCustomBillingCycle(body, options);
    return resp;
  };
});
const postExcludeCorrectionAsync = createAsync(body => {
  return async function postExcludeCorrection(options) {
    const resp = await api.Allocations.postExcludeCorrection(body, options);
    return resp;
  };
});
const postIncludeCorrectionAsync = createAsync(body => {
  return async function postIncludeCorrection(options) {
    const resp = await api.Allocations.postIncludeCorrection(body, options);
    return resp;
  };
});
const postReviewAsync = createAsync(body => {
  return async function postReview(options) {
    const resp = await api.Allocations.postReview(body, options);
    return resp;
  };
});
const createAllocationChargesAsync = createAsync(body => {
  return async function createAllocationCharges(options) {
    const resp = await api.Allocations.createAllocationChargesBatch(body, options);
    return resp;
  };
});
const postSubMeterHistoryAsync = createAsync(body => {
  return async function postSubMeterHistory(options) {
    const resp = await api.Allocations.postSubMeterHistory(body, options);
    return resp;
  };
});
const postGetSubmeterChargesFinalStateAsync = createAsync(body => {
  return async function postGetSubmeterChargesFinalState(options) {
    const resp = await api.Allocations.postGetSubmeterChargesFinalState(body, options);
    return resp;
  };
});
const getSubmeterUnitMapAsync = createAsync(body => {
  return async function getSubmeterUnitMap(options) {
    const resp = await api.Allocations.getSubmeterUnitMap(body, options);
    return resp;
  };
});
const postSubmeterUnitMapAsync = createAsync(body => {
  return async function postSubmeterUnitMap(options) {
    const resp = await api.Allocations.postSubmeterUnitMap(body, options);
    return resp;
  };
});
const getSubmeterCsvMapsAsync = createAsync(() => {
  return async function getSubmeterCsvMaps(options) {
    const resp = await api.Allocations.getSubmeterCsvMaps(options);
    return resp;
  };
});
const postSubmeterCsvMapAsync = createAsync(body => {
  return async function postSubmeterCsvMap(options) {
    const resp = await api.Allocations.postSubmeterCsvMap(body, options);
    return resp;
  };
});
const postSubmeterParseCsvAsync = createAsync(body => {
  return async function postSubmeterParseCsv(options) {
    const resp = await api.Allocations.postSubmeterParseCsv(body, options);
    return resp;
  };
});
const postSubmeterBillingParseCsvAsync = createAsync(body => {
  return async function postSubmeterBillingParseCsv(options) {
    const resp = await api.Allocations.postSubmeterBillingParseCsv(body, options);
    return resp;
  };
});
const getSubmeterBillingAllocationsAsync = createAsync(body => {
  return async function getSubmeterBillingAllocations(options) {
    const resp = await api.Allocations.getSubmeterBillingAllocations(body, options);
    return resp;
  };
});
const postSubmeterBillingAllocationsSaveAsync = createAsync(body => {
  return async function postSubmeterBillingAllocationsSave(options) {
    const resp = await api.Allocations.postSubmeterBillingAllocationsSave(body, options);
    return resp;
  };
});
const putSubmeterBillingAllocationsAsync = createAsync(body => {
  return async function putSubmeterBillingAllocations(options) {
    const resp = await api.Allocations.putSubmeterBillingAllocations(body, options);
    return resp;
  };
});
const getSubmeterBillingAllocationsVarianceAsync = createAsync(body => {
  return async function getSubmeterBillingAllocationsVariance(options) {
    const resp = await api.Allocations.getSubmeterBillingAllocationsVariance(body, options);
    return resp;
  };
});
const getSubmeterBillingAllocationsUnmappedBillableUnitsAsync = createSilentAsync(body => {
  return async function getSubmeterBillingAllocationsUnmappedBillableUnits(options) {
    const resp = await api.Allocations.getSubmeterBillingAllocationsUnmappedBillableUnits(body, options);
    return resp;
  };
});
const postSubmeterBillingAllocationsReviewAsync = createSilentAsync(body => {
  return async function postSubmeterBillingAllocationsReview(options) {
    const resp = await api.Allocations.postSubmeterBillingAllocationsReview(body, options);
    return resp;
  };
});
const postSubmeterBillingAllocationsApproveAsync = createSilentAsync(body => {
  return async function postSubmeterBillingAllocationsApprove(options) {
    const resp = await api.Allocations.postSubmeterBillingAllocationsApprove(body, options);
    return resp;
  };
});
const getSubmeterBillingCsvMapsAsync = createAsync(body => {
  return async function getSubmeterBillingCsvMaps(options) {
    const resp = await api.Allocations.getSubmeterBillingCsvMaps(body, options);
    return resp;
  };
});
const getSubmeterBillingCsvMapAsync = createAsync(body => {
  return async function getSubmeterBillingCsvMap(options) {
    const resp = await api.Allocations.getSubmeterBillingCsvMap(body, options);
    return resp;
  };
});
const postSubmeterBillingCsvMapAsync = createAsync(body => {
  return async function postSubmeterBillingCsvMap(options) {
    const resp = await api.Allocations.postSubmeterBillingCsvMap(body, options);
    return resp;
  };
});
const putSubmeterBillingCsvMapAsync = createAsync(body => {
  return async function putSubmeterBillingCsvMap(options) {
    const resp = await api.Allocations.putSubmeterBillingCsvMap(body, options);
    return resp;
  };
});
const deleteSubmeterBillingCsvMapAsync = createAsync(body => {
  return async function deleteSubmeterBillingCsvMap(options) {
    const resp = await api.Allocations.deleteSubmeterBillingCsvMap(body, options);
    return resp;
  };
});
const getSubmeterBillingUnitMeterMapsAsync = createAsync(body => {
  return async function getSubmeterBillingUnitMeterMaps(options) {
    const resp = await api.Allocations.getSubmeterBillingUnitMeterMaps(body, options);
    return resp;
  };
});
const postSubmeterBillingUnitMeterMapsByPropertyUtilityAsync = createAsync(body => {
  return async function postSubmeterBillingUnitMeterMapsByPropertyUtility(options) {
    const resp = await api.Allocations.postSubmeterBillingUnitMeterMapsByPropertyUtility(body, options);
    return resp;
  };
});
const deleteSubmeterBillingUnitMeterMapsByPropertyUtilityAsync = createAsync(body => {
  return async function deleteSubmeterBillingUnitMeterMapsByPropertyUtility(options) {
    const resp = await api.Allocations.deleteSubmeterBillingUnitMeterMapsByPropertyUtility(body, options);
    return resp;
  };
});
const postSubmeterBillingUnitMeterMapsBatchAsync = createAsync(body => {
  return async function postSubmeterBillingUnitMeterMapsBatch(options) {
    const resp = await api.Allocations.postSubmeterBillingUnitMeterMapsBatch(body, options);
    return resp;
  };
});
const postGetSubMeterFinalStateAsync = createAsync(body => {
  return async function postGetSubMeterFinalState(options) {
    const resp = await api.Allocations.postGetSubMeterFinalState(body, options);
    return resp;
  };
});
const Period = types.model({
  allocationCharge: types.number,
  allocationId: types.string,
  occupancyFactor: types.number,
  periodEndDateOnly: types.string,
  periodStartDateOnly: types.string,
  residentShare: types.number
});
const Allocation = types.model({
  allocationCharge: types.number,
  allocationId: types.string,
  billingCycleTotal: types.maybeNull(types.number),
  correction: types.maybeNull(types.number),
  commonAreaDeduction: types.maybeNull(types.number),
  daysOccupied: types.number,
  occupancyFactor: types.number,
  occupantsCount: types.number,
  periods: types.array(Period),
  proRataFactor: types.number,
  proratedOccupancyFactor: types.number,
  residentAccountId: types.maybeNull(types.string),
  residentId: types.maybeNull(types.string),
  unitName: types.string,
  unitOccupancyFactor: types.number
});
const Bill = types.model({
  amount: types.maybe(types.number),
  endDateOnly: types.maybe(types.string),
  fileId: types.maybeNull(types.string),
  redactedFileId: types.maybeNull(types.string),
  goodwillDeduction: types.maybe(types.number),
  id: types.maybe(types.string),
  isSkipped: types.maybe(types.boolean),
  isShared: types.maybe(types.maybeNull(types.boolean)),
  startDateOnly: types.maybe(types.string),
  utilityId: types.maybe(types.string)
});
const BillAllocation = types.model({
  billId: types.maybeNull(types.string),
  billStatus: types.string,
  billingCycleId: types.string,
  billValue: types.maybeNull(types.number),
  commonAreaDeduction: types.number,
  goodwillDeduction: types.maybeNull(types.number),
  rationBilled: types.number,
  serviceEndDateOnly: types.maybeNull(types.string),
  serviceStartDateOnly: types.maybeNull(types.string),
  submetered: types.number,
  total: types.number,
  utilityId: types.string
});
const BillFile = types.model({
  propertyId: types.string,
  utilityId: types.string,
  fileId: types.maybeNull(types.string),
  allocationName: types.string,
  serviceDateFrom: types.string,
  serviceDateTo: types.string,
  fileUploadedBy: types.maybeNull(types.string)
});
const Cycle = types.model({
  daysTillStatementDate: types.number,
  dueDate: types.string,
  endDateOnly: types.string,
  id: types.string,
  month: types.number,
  name: types.string,
  startDateOnly: types.string,
  statementDate: types.string,
  year: types.number
});
const CycleChargesPreview = types.model({
  residentAccountId: types.maybeNull(types.string),
  residentId: types.maybeNull(types.string),
  totalStatement: types.number,
  unitName: types.string,
  utilityCaps: types.number,
  statementCap: types.maybeNull(types.number),
  utilityCharges: types.number
});
export const AllocationUtility = types.model({
  allocated: types.number,
  allocationMethod: types.string,
  allocations: types.optional(types.array(Allocation), []),
  bill: types.maybeNull(Bill),
  billStatus: types.maybeNull(types.string),
  billTotal: types.number,
  bills: types.optional(types.array(Bill), []),
  commonAreaDeduction: types.number,
  deductions: types.number,
  defaultGoodwillDeduction: types.number,
  isApproved: types.boolean,
  isEditable: types.boolean,
  isSkipped: types.boolean,
  ratioBilledTotal: types.number,
  recovery: types.number,
  utilityId: types.string,
  utilityType: types.maybeNull(types.string)
});
const Table = types.model({
  allocationBatchId: types.maybeNull(types.string),
  cycleChargesPreview: types.optional(types.array(CycleChargesPreview), []),
  enrolledUnitsCount: types.number,
  totalUnitsCount: types.number,
  utilityTables: types.optional(types.array(AllocationUtility), [])
});
const AllocationHistory = types.model('AllocationHistory', {
  allocationCycleId: types.string,
  month: types.number,
  propertyId: types.string,
  utilities: types.optional(types.array(BillAllocation), []),
  year: types.number,
  ym: types.number
});
const Counter = types.model('Counter', {
  TableReadyStatementSent: types.array(types.string),
  TableSkipped: types.array(types.string)
});
const History = types.model('History', {
  propertyId: types.string,
  utilityId: types.string
});
const Queue = types.model('Queue', {
  billingCycleId: types.string,
  id: types.string,
  propertyId: types.string,
  utilityId: types.maybeNull(types.string)
});
const SkippedCycle = types.model('SkippedCycle', {
  id: types.string,
  month: types.number,
  name: types.string,
  year: types.number
});
const Summary = types.model('Summary', {
  expectedEnrolledPayout: types.number,
  recoveryFullEnrollment: types.number,
  totalBillAmount: types.number
});
const Preview = types.model('Preview', {
  allocationMethod: types.string,
  billStatus: types.string,
  isEditable: types.boolean,
  isSkipped: types.boolean,
  utilityId: types.string
});
const TablePreview = types.model('Preview', {
  isDefaultBillingCycle: types.boolean,
  isHistoricalAllocationCycle: types.boolean,
  utilityTables: types.array(Preview)
});
const AllocationsStore = types.model('AllocationsStore', {
  allocationBatchIdValue: types.maybeNull(types.string),
  allocationBatchIdForUtility: types.map(types.string),
  allocationHistoryCounterValues: types.map(Counter),
  allocationHistoryModalIsOpenValue: types.optional(types.boolean, false),
  allocationHistoryValues: types.optional(types.array(AllocationHistory), []),
  allocationUtilityIdsValues: types.optional(types.array(types.string), []),
  batchQueueValues: types.array(types.string),
  batchedValues: types.array(types.string),
  billAllocations: types.map(types.array(BillAllocation)),
  billFilesValue: types.map(types.array(BillFile)),
  billingCyclesFetchedValue: types.map(types.boolean),
  currentCycleValues: types.optional(Cycle, {
    daysTillStatementDate: 0,
    dueDate: '',
    endDateOnly: '',
    id: '',
    month: 0,
    name: '',
    startDateOnly: '',
    statementDate: '',
    year: 0
  }),
  chargesPreviewForSelectedCycleValues: types.map(types.array(CycleChargesPreview)),
  cyclesIds: types.map(types.string),
  deleteBillingCycleAsync,
  removeBillAsync,
  historyPreviewSelectedTabValue: types.optional(types.string, ''),
  historyDataValue: types.optional(History, {
    propertyId: '',
    utilityId: ''
  }),
  historyValues: types.optional(types.array(Cycle), []),
  // note: AppFolio only
  propertyDefaultChargeOnDate: types.maybeNull(types.string),
  getAddBillingCycleAsync,
  getAllocationComparisonAsync,
  getAllocationHistoryAsync,
  getAllocationPreviewAsync,
  getAllocationsHistoryAsync,
  getAllocationTableAggregateAsync,
  getAllocationTableInfoAsync,
  getBillingCyclesAsync,
  getBillingSummaryAsync,
  getBillsAsync,
  getBillsFileCabinetAsync,
  getCurrentCycleAsync,
  getFileAttachedAsync,
  getPropertyBillsFileCabinetAsync,
  getSkippedCyclesAsync,
  isAttachBillFileModalOpen: types.map(types.string),
  isTableLoadingValue: types.optional(types.boolean, false),
  postAllocationSuggestionAsync,
  postBillCreatedAsync,
  postExcludeCorrectionAsync,
  postIncludeCorrectionAsync,
  postReviewAsync,
  createAllocationChargesAsync,
  postSubMeterHistoryAsync,
  postGetSubMeterFinalStateAsync,
  postGetSubmeterChargesFinalStateAsync,
  getSubmeterUnitMapAsync,
  postSubmeterUnitMapAsync,
  getSubmeterCsvMapsAsync,
  postSubmeterCsvMapAsync,
  postSubmeterParseCsvAsync,
  postSubmeterBillingParseCsvAsync,
  getSubmeterBillingAllocationsAsync,
  postSubmeterBillingAllocationsSaveAsync,
  putSubmeterBillingAllocationsAsync,
  getSubmeterBillingAllocationsVarianceAsync,
  getSubmeterBillingAllocationsUnmappedBillableUnitsAsync,
  postSubmeterBillingAllocationsReviewAsync,
  postSubmeterBillingAllocationsApproveAsync,
  getSubmeterBillingCsvMapsAsync,
  getSubmeterBillingCsvMapAsync,
  postSubmeterBillingCsvMapAsync,
  putSubmeterBillingCsvMapAsync,
  deleteSubmeterBillingCsvMapAsync,
  getSubmeterBillingUnitMeterMapsAsync,
  postSubmeterBillingUnitMeterMapsByPropertyUtilityAsync,
  deleteSubmeterBillingUnitMeterMapsByPropertyUtilityAsync,
  postSubmeterBillingUnitMeterMapsBatchAsync,
  postTableApprovalAsync,
  postCustomBillingCycleAsync,
  propertyAddressValue: types.map(types.string),
  propertyNameValue: types.maybeNull(types.string),
  putBillUpdatedAsync,
  queueValues: types.array(Queue),
  selectedBillingCycle: types.optional(types.string, 'initial'),
  selectedPropertyValue: types.optional(types.string, ''),
  skippedCyclesValue: types.optional(types.array(SkippedCycle), []),
  summary: types.map(Summary),
  tablePreviewValue: types.map(TablePreview),
  tableValues: types.optional(Table, {
    cycleChargesPreview: [],
    enrolledUnitsCount: 0,
    totalUnitsCount: 0,
    utilityTables: []
  }),
  tabsValue: types.optional(types.array(types.string), []),
  utilityById: types.map(AllocationUtility),
  utilityByIdTimestamp: types.map(types.number)
}).actions(store => {
  return {
    addBatched(id) {
      try {
        if (id && !store.batchedValues.includes(id)) store.batchedValues.push(id);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    addToQueue(data) {
      try {
        if (!store.queueValues.find(item => item.id === data.id)) store.queueValues.push(data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    clearAllocationHistory() {
      try {
        store.allocationHistoryValues.clear();
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    deleteAllocationBatchIdForUtility(id) {
      try {
        store.allocationBatchIdForUtility.set(id, '');
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    removeFromQueue(data) {
      try {
        store.queueValues = cast(store.queueValues.filter(item => item.id !== data.id));
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    removeFromQueueBatch(id) {
      try {
        store.batchQueueValues = cast(store.batchQueueValues.filter(item => item !== id));
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setAllocationHistoryAfterLoad(data) {
      try {
        var _data$response;
        store.allocationHistoryCounterValues = data.response.reduce((acc, item) => {
          const TableReadyStatementSent = item.utilities.filter(utility => utility.billStatus === 'TableReadyStatementSent').map(utility => utility.utilityId);
          const TableSkipped = item.utilities.filter(utility => utility.billStatus === 'TableSkipped').map(utility => utility.utilityId);
          acc[item.allocationCycleId] = {
            TableReadyStatementSent,
            TableSkipped
          };
          return acc;
        }, {});
        store.allocationHistoryValues = data.response.map(a => _objectSpread(_objectSpread({}, a), {}, {
          ym: +"".concat(a.year).concat(a.month.toString().padStart(2, '0'))
        })).sort(sortCycles);
        if ((_data$response = data.response) !== null && _data$response !== void 0 && _data$response.length) {
          const unicUtilityIds = [];
          data.response.forEach(historyItem => {
            var _historyItem$utilitie;
            if (historyItem !== null && historyItem !== void 0 && (_historyItem$utilitie = historyItem.utilities) !== null && _historyItem$utilitie !== void 0 && _historyItem$utilitie.length) {
              historyItem.utilities.map(ut => unicUtilityIds.push(ut.utilityId));
            }
          });
          store.allocationUtilityIdsValues = cast([...new Set(unicUtilityIds)]);
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setAllocationsHistoryAfterLoad(data) {
      try {
        store.historyValues = cast(data.response);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setAllocationBatchId(id) {
      try {
        store.allocationBatchIdValue = id;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setAllocationHistoryModalIsOpen(value) {
      try {
        store.allocationHistoryModalIsOpenValue = value;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setBillsAfterLoad(data) {
      try {
        store.billAllocations = data.response.reduce((acc, item) => {
          acc[item.propertyId] = item.utilities;
          return acc;
        }, {});
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setBillFiles(propertyId, data) {
      try {
        store.billFilesValue.set(propertyId, data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setBillingCyclesFetched(id) {
      try {
        if (id) store.billingCyclesFetchedValue.set(id, true);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setCurrentCycleAfterLoad(data) {
      try {
        store.currentCycleValues = _objectSpread({}, data.response);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setCurrentPropertyDefaultChargeOnDate(dateString) {
      try {
        store.propertyDefaultChargeOnDate = dateString;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setCyclesId(id, name) {
      try {
        if (id && name) store.cyclesIds.set(id, name);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setHistoryData(propertyId, utilityId) {
      try {
        store.historyDataValue = cast({
          propertyId,
          utilityId
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setHistoryPreviewSelectedTab(tab) {
      try {
        store.historyPreviewSelectedTabValue = tab;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setIsAttachBillFileModalOpen(value, utilityName) {
      try {
        store.isAttachBillFileModalOpen.set(value, utilityName);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setIsTableLoading(value) {
      try {
        store.isTableLoadingValue = value;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setCycleAfterLoad(id, data) {
      try {
        store.tablePreviewValue.set(id, data.response);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPropertyAddress(propertyId, address) {
      try {
        if (propertyId && address) store.propertyAddressValue.set(propertyId, address);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setSelectedBillingCycleId(id) {
      try {
        store.selectedBillingCycle = id;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setSelectedProperty(propertyId) {
      try {
        store.selectedPropertyValue = propertyId;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setSkippedCyclesAfterLoad(data) {
      try {
        store.skippedCyclesValue = cast(data.response);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setTableAfterLoad(data, id) {
      try {
        store.chargesPreviewForSelectedCycleValues.set(id, [...data.response.cycleChargesPreview]);
        store.propertyNameValue = data.response.propertyName;
        store.summary.set(id, {
          expectedEnrolledPayout: data.response.expectedEnrolledPayout,
          recoveryFullEnrollment: data.response.recoveryFullEnrollment,
          totalBillAmount: data.response.totalBillAmount
        });
        store.tableValues = data.response;
        const allocationBatchId = data.response.allocationBatchId;
        if (allocationBatchId && !store.batchQueueValues.includes(allocationBatchId) && !store.batchedValues.includes(allocationBatchId)) store.batchQueueValues.push(allocationBatchId);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setTabs(tabs) {
      try {
        store.tabsValue = cast(tabs);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setUtilityAfterLoad(billingCycleId, utilityId, data) {
      try {
        const allocationBatchId = data.response.allocationBatchId;
        if (allocationBatchId && !store.batchQueueValues.includes(allocationBatchId) && !store.batchedValues.includes(allocationBatchId)) {
          store.allocationBatchIdForUtility.set(data.response.allocationBatchId, utilityId);
          store.batchQueueValues.push(allocationBatchId);
        }
        if (data.response.utilityTables.length > 0) {
          store.utilityById.set(billingCycleId + utilityId, data.response.utilityTables.find(utility => utility.utilityId === utilityId));
          store.utilityByIdTimestamp.set(billingCycleId + utilityId, moment().unix());
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateUtility(id, data) {
      try {
        store.utilityById.set(id, data);
        store.utilityByIdTimestamp.set(id, moment().unix());
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  get allocationBatchId() {
    return store.allocationBatchIdValue;
  },
  get allocationCounters() {
    return toJS(store.allocationHistoryCounterValues);
  },
  get allocationHistory() {
    return toJS(store.allocationHistoryValues);
  },
  get allocationHistoryModalIsOpen() {
    return store.allocationHistoryModalIsOpenValue;
  },
  get allocationUtilityIds() {
    return toJS(store.allocationUtilityIdsValues);
  },
  get batched() {
    return toJS(store.batchedValues);
  },
  get billAllocationsList() {
    return store.billAllocations;
  },
  get billFiles() {
    return store.billFilesValue;
  },
  get billingCyclesFetched() {
    return store.billingCyclesFetchedValue;
  },
  get chargesPreviewForSelectedCycle() {
    return toJS(store.chargesPreviewForSelectedCycleValues).get(store.selectedBillingCycle);
  },
  get cycleChargesPreviewList() {
    return toJS(store.tableValues.cycleChargesPreview);
  },
  get currentCycle() {
    return store.currentCycleValues;
  },
  get history() {
    return store.historyValues;
  },
  get historyData() {
    return store.historyDataValue;
  },
  get historyPreviewSelectedTab() {
    return store.historyPreviewSelectedTabValue;
  },
  get isTableLoading() {
    return store.isTableLoadingValue;
  },
  get propertyAddress() {
    return store.propertyAddressValue;
  },
  get propertyName() {
    return store.propertyNameValue;
  },
  get queue() {
    return toJS(store.queueValues);
  },
  get batchQueue() {
    return store.batchQueueValues;
  },
  get selectedBillingCycleId() {
    return store.selectedBillingCycle;
  },
  get selectedProperty() {
    return store.selectedPropertyValue;
  },
  get skippedCycles() {
    return toJS(store.skippedCyclesValue);
  },
  get table() {
    return toJS(store.tableValues);
  },
  get tablePreview() {
    return toJS(store.tablePreviewValue);
  },
  get tabs() {
    return store.tabsValue;
  },
  get utilityTablesList() {
    return toJS(store.tableValues.utilityTables);
  }
}));
export const allocations = types.optional(AllocationsStore, {});